<ngx-spinner [name]="spinner1" [fullScreen]="true"><span class="badge badge-info p-2">Autorisierung wird durchgeführt...</span></ngx-spinner>
<app-message [service]="messageService"></app-message>
<div class="container-fluid-0px">
  <div class="row">
    <div class="col-12 ps-3 ">
      <h5 class="my-3" i18n="@@InfomationStatusHeader">
        Berechtigungen für diese Ladestation setzen
      </h5>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12 col-md-12 col-lg-12">
      <div class="container g-1">
        <div class="row g-2 pb-2 mb-2">
          <form [formGroup]="formService.form" (ngSubmit)="onSubmit(formService.form.value)" *ngIf="formReady">
            <label for="selectedAllowedUsers" class="form-label persistent" i18n="@@UserLabel">Benutzer:</label>
            <ng-select #selectedAllowedUsers id="users" [items]="allUsers" [multiple]="true"
                       [closeOnSelect]="false" [clearSearchOnAdd]="true" [searchable]="true" appendTo="body" [hideSelected]="true"
                       notFoundText="Keine Einträge vorhanden" i18n-notFoundText="@@NoEntriesAvailable"
                       formControlName="selectedAllowedUsers" i18n-placeholder="@@Users" placeholder="Benutzer" [searchFn]="customSearchFn"
                       [compareWith]="compareFn">

              <ng-template ng-label-tmp let-item="item">
                <span class="px-2">{{ item.fullName + ' (' + item.email +')' }}</span>
                <span class="ng-value-icon right" (click)="clear(item)">×</span>

              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
                <span class="px-2">{{ item.fullName + ' (' + item.email +')' }}</span>
              </ng-template>
            </ng-select>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="isOperator" class="container-fluid-0px">
  <div class="row">
    <div class="col-12 ps-3 ">
      <h5 class="my-3" i18n="@@LastAuthenticationAttemptStateHeader">
        Status des letzten Autorisierungsversuchs
      </h5>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12 col-md-12 col-lg-12">
      <div class="container g-1 mt-2 pl-3" *ngIf="ChargingStationAuthorizationResponse">
        <div class="row g-2 pb-2 mb-2">
          Status der Ladestation bei der Autorisierung:
          <b>{{ ChargingStationAuthorizationResponse?.online ? 'Online' : 'Offline'}}</b>
        </div>
        <div class="row g-2 pb-2 mb-2">
          Nachrichten von der Ladestation bei der Autorisierung:
          <b>{{ ChargingStationAuthorizationResponse?.status? ChargingStationAuthorizationResponse.status : 'Nichts'}}</b>
        </div>
        <div class="row g-2 pb-2 mb-2">
          Zeit des letzten Autorisierungsversuchs:
          <b>{{ ChargingStationAuthorizationResponse?.updatedAt? ChargingStationAuthorizationResponse.updatedAt :'Nicht bekannt'}}</b>
        </div>
      </div>
      <div class=" h-100 text-center align-middle" *ngIf="!ChargingStationAuthorizationResponse">
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg><br />
        <span class="pt-3" i18n="@@NoEntriesAvailable">Keine Einträge vorhanden.</span>
      </div>
    </div>
  </div>
</div>
<div class="container-fluid-0px">
  <div class="row">
    <div class="col-12 ps-3 ">
      <h5 class="my-3" i18n="@@ChargingstationWhitelistSyncNowHeader">
        Whiteliste jetzt synchronisieren
      </h5>
      <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="synchronWhitelistNow()" i18n="@@SyncButton">
        Synchronisieren
      </button>
    </div>
  </div>
</div>


